module.exports = __webpack_public_path__ + "img/power_panda_256.04d1b914.png";